<template>
  <span
    v-if="user.tag1 || user.tag2"
    class="user-tag">{{ user | userTag }}</span>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/variable';

.user-tag {
  display: inline-block;
  align-self: center;
  font-size: 11px;
  line-height: 1.2;
  padding: 1px 5px;
  border-radius: 3px;
  background: $grey10;
  color: $grey08;
  margin-right: 2px;
}
</style>
